import { Driver } from '../models/Driver'
import { ValidationUtils } from './ValidationUtils';

export class TextUtils {

  public static getDriverName(driver: Driver): string {
    return `${driver.firstName?.charAt(0)?.toUpperCase()}.${driver.lastName}`
  }

    public static getEmailUsername(email: string): string {
    let username = ''
    if(email) {
      const emailPattern = email.match(ValidationUtils.EMAIL_GROUP_PATTERN)
      username = emailPattern?.[1] ?? ''
    }
    return username
  }

  public static getEmailDomain(email: string): string {
    let domain = ''
    if(email) {
      const emailGroups = email.match(ValidationUtils.EMAIL_GROUP_PATTERN)
      domain = emailGroups?.[2] ?? ''
    }
    return domain
  }
}
